import { enqueueSnackbar } from 'notistack';
import { axiosInstance } from './axios.utils';
import CustomError from '../components/CustomError/CustomError';

function getBEFilename(headers, defaultName) {
  const contentDisposition = headers['content-disposition'];
  const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
  return fileNameMatch ? fileNameMatch[1] : defaultName;
}

export async function httpFileDownload(
  token,
  downloadUrl,
  body,
  headers,
  onSuccess = () => {},
  onError = () => {},
  snackBarErrorMessage = 'Error trying to download, please try again.',
  customFileName,
  onProgress = () => {},
  signal
) {
  if (!downloadUrl || !token) return;
  try {
    axiosInstance
      .post(
        downloadUrl,
        {
          ...body
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            ...(headers || {})
          },
          responseType: 'blob',
          onDownloadProgress: progressEvent => {
            !!onProgress && onProgress(progressEvent.loaded, progressEvent.total);
          },
          ...(signal ? { signal } : {})
        }
      )
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        let filename = getBEFilename(response?.headers, customFileName);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        onSuccess(response);
      })
      .catch(e => {
        enqueueSnackbar(<CustomError message={snackBarErrorMessage} />, {
          variant: 'error',
          preventDuplicate: true,
          autoHideDuration: null
        });
        onError(e);
      });
  } catch (e) {
    enqueueSnackbar(<CustomError message={snackBarErrorMessage} />, {
      variant: 'error',
      preventDuplicate: true,
      autoHideDuration: null
    });
    onError(e);
  }
}
